import { Button } from '@/components/ui/button'
import { useIsMobileClient } from '@/hooks/common/use-device-type'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { TRandomBannerImageItem } from '@/types/collection'
import Image from 'next/image'
import Link from 'next/link'

export const CollectionRandomBannerCard = ({
  banner,
  collectionTitle,
}: {
  banner: TRandomBannerImageItem
  collectionTitle?: string
}) => {
  const isMobile = useIsMobileClient()
  const hasContent = banner.title || banner.desc || banner.cta

  return (
    <Link
      href={banner.url || '#'}
      className={cn(
        'relative block h-full w-full overflow-hidden rounded-md pb-[133.33%] md:pb-[150%]',
        banner.url ? 'cursor-pointer' : 'cursor-default'
      )}
      ga-tracking-value={`listing_random_banner_${collectionTitle}_${banner.order}`}
      ga-tracking-label='listing random banner'
    >
      <Image
        src={ImageHelper.getN7ImageUrl(banner.src)}
        alt='Random Banner'
        fill
        className='object-cover'
        sizes='(max-width: 768px) 50vw, (max-width: 1024px) 25vw, 20vw'
      />
      {hasContent && (
        <div className='absolute bottom-0 left-0 right-0 bg-neutral-900 px-2 py-3 md:px-4'>
          {banner.title && (
            <h3 className='line-clamp-2 font-criteria text-sm text-white md:text-lg'>
              {banner.title}
            </h3>
          )}
          {banner.desc && (
            <p className='mt-1 line-clamp-2 text-xs text-gray-300 md:text-sm'>
              {banner.desc}
            </p>
          )}
          {banner.cta && (
            <Button
              variant='white'
              className='mt-2'
              size={isMobile ? 'small' : 'default'}
              asChild
            >
              <span>{banner.cta}</span>
            </Button>
          )}
        </div>
      )}
    </Link>
  )
}
